import React from 'react';

import {ArgosJobEditFormWrapper} from '@modules/events/components/ArgosJobEditFormWrapper';
import {showModal} from '@utils/modal';

export const buildEventDataFromArgosLiveControlRow = (row) => ({
    start_datetime: row.event_start_datetime,
    end_datetime: row.event_end_datetime,
    event_type: {id: row.event_type_id},
});

export const openArgosJobConfigureModal = ({row, onSaveSuccess}) => {
    showModal({
        isVisible: true,
        size: 'large',
        className: 'argosJobModal',
        content: (
            <ArgosJobEditFormWrapper
                eventId={row.event_id}
                argosJobId={row.id}
                eventData={buildEventDataFromArgosLiveControlRow(row)}
                jobs={[{id: row.id}]}
                onSaveSuccess={onSaveSuccess}
            />
        ),
    });
};
